import {IUserPreferences} from "../../interfaces/IUserPreferences";
import {ISurveyFilters} from "../../types/IBuildSurveyParams";

export const mapUserPreferencesToSurveyFiltersData = (userPreferences: IUserPreferences | null | undefined): ISurveyFilters | null => {
    if (userPreferences?.filters) {
        return {
            region: userPreferences.filters.region,
            price_1: userPreferences.filters.price_1 || undefined,
            rooms_0: userPreferences.filters.rooms_0,
            rooms_1: userPreferences.filters.rooms_1
        };
    }

    return null;
};
import {IUserPreferences} from "../../interfaces/IUserPreferences";
import {ISurveyFilters} from "../../types/IBuildSurveyParams";

export const mapUserPreferencesToSurveyFiltersData = (userPreferences: IUserPreferences | null | undefined): ISurveyFilters | null => {
    if (userPreferences?.filters) {
        return {
            region: userPreferences.filters.region,
            price_1: userPreferences.filters.price_1 || undefined,
            rooms_0: userPreferences.filters.rooms_0,
            rooms_1: userPreferences.filters.rooms_1
        };
    }

    return null;
};
